import { configStore, initiaizeCommonState, setCommonState, 
    quoteStore, customerStore, loginStore, entityStore, contractsStore } from "../state/CommonState"
import { useEffect, useRef, useState } from "react"
import { act } from "react-dom/test-utils";
import Api from "../state/Api";
import { useSnapshot } from "valtio";
import EntityApi from "../state/entity-api";
import Utils from "../util/Utils";

export default function QuoteListClient() {
    const [activeTab, setActiveTab] = useState('Quotations')
    const tablist = ['Quotations', 'Contracts']
    useSnapshot(quoteStore)
    const [space, setSpace] = useState('')
    const txtSearch = useRef()
    //let quoteList = quoteStore.listData.quotesList
    const [quoteList, setQuoteList] = useState(quoteStore.listData.quotesList)
    useEffect(() => {
        Api.getQuotes(setQuoteList)
        EntityApi.getList()
        Api.getContracts()
    }, [])
    //console.log('quoteList=', JSON.stringify(quoteList) )
    const myRole = loginStore.userRec.aguserRec.role
    const canEdit = (['CUSTOMER SERVICE', 'SALES', `${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()} ADMIN`, 'PRODUCTS'].indexOf(myRole) >= 0)
    let list = []
    let dateFromLabel = 'Quotation Date'
    let refNumLabel = 'Quotation Reference #'
    if (activeTab === 'Quotations') {
        /*list = quoteList.filter(e => e.status !== 'ACCEPTED').map(e => {
            const s = e.quoteSummary
            return {
                quoteDate: e.mailedOn,
                quoteNum: e._id,
                origin: s.origin,
                destination: s.destination,
                validUpto: e.quoteData.validUpto
            }
        })*/
        list = contractsStore.list.filter(e => e.mode === 'QUOTE').map(e => {
            return {
                quoteDate: e.mailedOn,
                quoteNum: e._id,
                origin: e.origin,
                destination: e.destination,
                validUpto: e.validUpto
            }
        })
    } else {
        dateFromLabel = 'Contract Effective Date'
        refNumLabel = 'Contract Reference #'
        list = contractsStore.list.filter(e => e.mode === 'CONTRACT').map(e => {
            return {
                quoteDate: e.mailedOn,
                quoteNum: e._id,
                origin: e.origin,
                destination: e.destination,
                validUpto: e.validUpto
            }
        })
    }
    return (
        <>
        <h5 className="title is-4" style={{color: process.env.REACT_APP_ENTERPRISE_COLOUR, fontFamily: 'product_sans_bold'}}>Create Booking{space}</h5>
            <div id="quotelistclient" className="tabs is-boxed" style={{marginBottom: '0px', backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR}}>
                <ul>
                    {
                        tablist.map(e => {
                            let className = ''
                            let styles = {color: 'lightgrey'}
                            if (e === activeTab) {
                                className = 'is-active'
                                styles = {backgroundColor: '#eea724', color: 'black'}
                            }
                            return <li className={className} onClick={() => setActiveTab(e)}>
                                <a style={styles}><span>{e}</span></a>
                            </li>
                        })
                    }
                </ul>
            </div>
            <div className="tabs" style={{marginTop: '0px', height: '5px', backgroundColor: '#eea724'}}></div>
            
            
            <div className="table-container">
                <table className="table is-narrow is-striped is-fullwidth is-hoverable ">
                    <thead>
                        <tr>
                            <th style={{width:'20%'}}>{dateFromLabel}</th>
                            <th style={{width:'20%'}}>{refNumLabel}</th>
                            <th style={{width:'20%'}}>Origin</th>
                            <th style={{width:'20%'}}>Destination</th>
                            <th style={{width:'20%'}}>Valid Till</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            list.map(e => {
                                return (
                                    <tr onClick={() => console.log('row cliked ...')}>
                                        <td>{Utils.convertDateformat(e.quoteDate)}</td>
                                        <td>{e.quoteNum}</td>
                                        <td>{e.origin}</td>
                                        <td>{e.destination}</td>
                                        <td>{Utils.convertDateformat(e.validUpto)}</td>
                                        <td>
                                            <div className="field has-addons">
                                                <p className="control">
                                                    <button className="button is-inverted"
                                                     style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
                                                        onClick={() => {
                                                            Api.getQuote(e._id)
                                                            configStore.quoteCurrentView = 'view'
                                                        }}>
                                                        <span className="icon is-small">
                                                            <i className="fas fa-calendar-days"></i>
                                                        </span>
                                                    </button>
                                                </p>
                                                <p className="control">
                                                    <button className="button is-success is-inverted"
                                                        onClick={() => {
                                                            Api.getQuote(e._id)
                                                            configStore.quoteCurrentView = 'view'
                                                        }}>
                                                        <span className="icon is-small">
                                                            <i className="fas fa-calendar-plus"></i>
                                                        </span>
                                                    </button>
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </>
    )
}